import { Heading } from './Heading';
import { spacingClass } from '@/utils/spacing';

/**
 * Testo semplice a sezioni (titolo + paragrafi) — per pagine come Privacy,
 * Termini e Condizioni, Cookie Policy. `body` rispetta gli a capo inseriti
 * nell'admin (whitespace-pre-line, niente markdown/HTML).
 * @param {{ title?: string, updatedAt?: string, sections?: Array<{ heading?: string, body?: string }>, spacing?: string, headingLevel?: number }} props
 */
export function LegalContentBlock({ title, updatedAt, sections = [], spacing = 'normal', headingLevel = 2 }) {
  return (
    <section className={'px-6 md:px-16 ' + spacingClass(spacing)}>
      <div className="max-w-2xl mx-auto">
        {title && <Heading level={headingLevel} className="font-heading text-h1 font-light text-theme-text mb-3">{title}</Heading>}
        {updatedAt && <p className="text-xs text-theme-text-subtle mb-10">{updatedAt}</p>}
        <div className="flex flex-col gap-8">
          {sections.map((s, i) => (
            <div key={i}>
              {s.heading && <Heading level={headingLevel + 1} className="font-heading text-h3 font-normal text-theme-text mb-2">{s.heading}</Heading>}
              {s.body && <p className="text-sm text-theme-text-muted leading-relaxed whitespace-pre-line">{s.body}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
